module.exports = __webpack_public_path__ + "fonts/Inter-800-greek74.8c7f6ae.woff2";